import React, { useEffect, useState } from 'react';
import useParam from '../../../../context/ParamContext';
import Chip from '@mui/material/Chip';
import { CheckboxUI } from '../../../Interface';
import { Box } from '@mui/material';

const ChipContent = ({ eventInfo, selectedTaskState }) => {
  const { selectedTaskIds, setSelectedTaskIds } = selectedTaskState;
  const task = eventInfo.event._def.extendedProps.eventData;

  const setChipContent = () => {
    if (!task) {
      return null;
    }

    const stopFcPropagation = (e) => {
      e.stopPropagation();
    };

    return (
      <span className="block" style={{ marginTop: '2px', marginBottom: '2px' }}>
        <Box display="flex" alignItems="center">
          {task.projectId && (
            <CheckboxUI
              onClick={stopFcPropagation}
              sx={{ m: 0, ml: -0.2, p: 0 }}
              checked={selectedTaskIds.includes(task.simpleTaskId)}
              onChange={() =>
                setSelectedTaskIds((prev) =>
                  prev.includes(task.simpleTaskId)
                    ? prev.filter((simpleTaskId) => simpleTaskId !== task.simpleTaskId)
                    : [...prev, task.simpleTaskId]
                )
              }
            />
          )}
          {`F: ${task.simpleTaskName}`}
        </Box>
        {`T: ${task?.taskType?.itemName}`}
        {task.resources.length > 0 && (
          <div style={{ marginTop: '4px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
            {task.resources
              .filter((resource) => resource.employeeId)
              .map((resource) => (
                <Chip
                  key={resource.simpleTaskId}
                  label={resource.employee?.name}
                  title={resource.employee?.name}
                  size="small"
                  sx={{
                    backgroundColor: resource.leader ? '#ffb7b7' : '#e0e0e0',
                    color: resource.leader ? 'red' : '#424242',
                    height: 20,
                    '.MuiChip-label': { paddingLeft: 6, paddingRight: 6 },
                  }}
                />
              ))}
          </div>
        )}
      </span>
    );
  };

  return <div>{setChipContent()}</div>;
};

export default ChipContent;
